var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBw = function SvgBw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M.567 8.348A11.989 11.989 0 0 0 0 12c0 1.274.199 2.5.567 3.652L12 16.174l11.433-.522C23.801 14.5 24 13.273 24 12c0-1.274-.2-2.5-.567-3.652L12 7.826.567 8.348Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24 12c0-.711-.062-1.409-.181-2.086H.18a12.063 12.063 0 0 0 0 4.173H23.82A12.07 12.07 0 0 0 24 12.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M12 24c5.354 0 9.888-3.507 11.433-8.348H.566C2.112 20.493 6.646 24 12 24ZM12 0C6.646 0 2.112 3.505.566 8.346h22.867C21.888 3.506 17.353 0 12 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgBw;